<script>
export default {
  props: {
    title: {
      type: String,
      default: '%USER%',
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    dataTestTitle: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      maxNameLength: 35,
    };
  },
  computed: {
    truncatedTitle() {
      return this.title.length > this.maxNameLength ? `${this.title.substring(0, this.maxNameLength)}...` : this.title;
    },
  },
};
</script>

<template lang="pug">
div
  div(:class="$style.title", :data-test="dataTestTitle", :title="title") {{ truncatedTitle }}
  div(:class="$style.subtitle", v-if="subtitle")  {{ subtitle }}
</template>

<style module lang="sass">
.title
  font-size: $title_size
  font-weight: $title_weight
  line-height: 20px
  cursor: pointer
.subtitle
  color: $color_text_second
  font-size: $subtitle_size
  font-weight: $subtitle_weight
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  line-height: 12px
  margin-top: 4px
  text-transform: uppercase

</style>
